import $ from 'jquery';

const WatchVideo = (breakPointTablet) => {
  if (document.getElementById('js-watch')) {
    const $btn = $('#js-watch');
    const $layer = $('#js-video');
    const $area = $('#js-area');
    const $video = $('#js-video > video');
    const video = document.getElementById('js-video__play');
    const $close = $('#js-video__close');
    $layer.on('click', function (e) {
      e.stopPropagation();
    })
    $area.on('click', function (e) {
      e.stopPropagation();
      watch();
    })
    $close.on('click', function (e) {
      e.stopPropagation();
      watch();
    })
    $btn.on('click', function (e) {
      e.stopPropagation()
      watch();
    })
    function watch() {
      $layer.toggleClass('is-view');
      if ($layer.hasClass('is-view')) {
        video.muted = false;
        video.currentTime = 0;
        video.play();
      } else {
        video.pause();
      }
      $btn.toggleClass('is-view');
      $area.toggleClass('is-watchingVideo');
      bodyFixed();
    }
  }

  function bodyFixed() {
    $('body').toggleClass('is-fixed');
    currentPositionCalculation();
  }
  function currentPositionCalculation() {

    // 背景固定
    const position = window.scrollY || window.pageYOffset;
    if ($('body').hasClass('is-fixed')) {
      // bodyを浮かせる
      $('body').css({
        'position': 'fixed',
        'top': `-${position}px`,
      });
    } else {
      // 解除
      const top = document.body.style.top;
      $('body').css({
        'top': '',
        'position': ''
      });
      window.scrollTo(0, parseInt(top) * -1);
    }
  }
}

export default WatchVideo;


// WEBPACK FOOTER //
// ./src/recruit/js/watchVideo.js